import 'css-chunksrc/client/scenes/assignToTask/projectSelection/input/styles.scss';export default {
  "input": "_input_tfup4_1",
  "opened": "_opened_tfup4_20",
  "toggleIcon": "_toggleIcon_tfup4_25",
  "placeholder": "_placeholder_tfup4_39",
  "selected": "_selected_tfup4_46",
  "name": "_name_tfup4_54",
  "folder": "_folder_tfup4_62",
  "icon": "_icon_tfup4_75",
  "tagIcon": "_tagIcon_tfup4_87"
};